var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./AverageScoreProgressBar.module.scss";
import { Status } from "../../common/action";
import { Icon, IconName, Link } from "@eightfold.ai/octuple";
var getStatusByScore = function (score) {
    if (score > 0 && score < 80) {
        return Status.Act;
    }
    if (score >= 80 && score <= 90) {
        return Status.Watch;
    }
    if (score > 90 && score <= 100) {
        return Status.Maintain;
    }
    return null;
};
export var getFactorScoreColor = function (score, colors) {
    var status = getStatusByScore(score);
    var statusIndexMap = {
        act: 0,
        watch: 1,
        maintain: 2,
    };
    if (status !== null) {
        var index = statusIndexMap[status.toLowerCase()];
        return {
            backgroundColor: colors === null || colors === void 0 ? void 0 : colors[index],
            border: "1px solid ".concat(status == Status.Act
                ? "var(--bad-2)"
                : status == Status.Watch
                    ? "var(--neutral-2)"
                    : status == Status.Maintain
                        ? "var(--good-2)"
                        : "var(--grey-color-350)"),
            backgroundClip: "border-box",
        };
    }
};
var Box = function (_a) {
    var value = _a.value, title = _a.title, colors = _a.colors, link = _a.link;
    var valueRounded = Math.round(value * 10) / 10;
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: styles.boxContainer }, { children: _jsx("div", __assign({ className: styles.leftSideContainer }, { children: _jsxs("div", __assign({ className: styles.titleArrowWrapper }, { children: [_jsx("div", __assign({ className: styles.titleWrapper }, { children: _jsx("span", __assign({ className: styles.titleStyle }, { children: title })) })), (link && link !== "") || link !== undefined ? (_jsx(Link, __assign({ onClick: function () {
                                    window.open("".concat(link), "_blank", "noopener,noreferrer");
                                }, className: styles.arrowStyle }, { children: _jsx(Icon, { classNames: styles.rigthArrow, path: IconName.mdiChevronRight }) }))) : (_jsx("span", __assign({ className: styles.arrowStyle }, { children: _jsx(Icon, { classNames: styles.rigthArrow, path: IconName.mdiChevronRight }) })))] })) })) })), _jsx("div", __assign({ className: styles.rightSideWrapper }, { children: _jsxs("div", __assign({ className: styles.rightSideContainer }, { children: [_jsx("div", __assign({ className: styles.targetValueBox, style: {
                                left: value < 10
                                    ? "calc(".concat(value, "% - 12px)")
                                    : value >= 10 && value < 90
                                        ? "calc(".concat(value, "% - 14px)")
                                        : value >= 90 && value <= 100
                                            ? "calc(".concat(value, "% - 45px)")
                                            : "".concat(value, "%"),
                                padding: "".concat(value < 10 ? "3px 9px" : "3px 6px"),
                                position: "absolute",
                                zIndex: 9,
                            } }, { children: valueRounded + "%" })), _jsxs("div", __assign({ className: styles.barStyle }, { children: [_jsx("div", { className: styles.filledPart, style: __assign(__assign({}, getFactorScoreColor(valueRounded, colors)), { width: "".concat(value, "%"), borderRadius: "10px 0 0 10px" }) }), _jsx("div", { className: styles.unfilledPart, style: {
                                        width: "".concat(100 - value, "%"),
                                    } })] }))] })) }))] }));
};
var Scrollbar = function (_a) {
    var score = _a.score, title = _a.title, colors = _a.colors, link = _a.link;
    var value = Math.round(score * 10) / 10;
    var nums = new Array(1).fill(0).map(function () {
        value -= 1;
        return value > 1 ? 1 : value >= 0 ? value : 0;
    });
    return (_jsx("div", __assign({ className: styles.boxesContainerMapping }, { children: nums === null || nums === void 0 ? void 0 : nums.map(function (n, i) { return (_jsx(Box, { length: n, value: score, title: title, show: true, colors: colors, link: link }, i)); }) })));
};
var AverageScoreProgressBar = function (_a) {
    var score = _a.score, title = _a.title, colors = _a.colors, link = _a.link;
    return (_jsx(_Fragment, { children: _jsx(Scrollbar, { "data-testid": "AverageScoreProgressBar", score: score, title: title, colors: colors, link: link }) }));
};
export default AverageScoreProgressBar;
